const GRADE_LEVEL = {
  MASTER_LEVEL: 'Master',
  DOCTOR_LEVEL: 'Doctor en ciencia',
  DOCTOR_C_LEVEL: 'Doctor en ciencias',
};
/**
 * Enum definition.
 *
 * @type {string[]}
 */
const GRADE_LEVEL_ENUM = Object.keys(GRADE_LEVEL);

const MASTER_LEVEL = GRADE_LEVEL_ENUM[0];
const DOCTOR_LEVEL = GRADE_LEVEL_ENUM[1];
const DOCTOR_C_LEVEL = GRADE_LEVEL_ENUM[2];

export {
  GRADE_LEVEL,
  GRADE_LEVEL_ENUM,
  MASTER_LEVEL,
  DOCTOR_LEVEL,
  DOCTOR_C_LEVEL,
};
